import { render, staticRenderFns } from "./alarms-detail.vue?vue&type=template&id=04b09c86&"
import script from "./alarms-detail.vue.js?vue&type=script&lang=js&"
export * from "./alarms-detail.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports